module.exports = __webpack_public_path__ + "img/Monegasque.42f6a16c.svg";